<template>
    <Header/>
    <!-- Hero Section -->
    <section class="product-detail-hero">
        <div class="container">
            <h1>{{ $t('salud_completa.hero_title') }}</h1>
            <p class="lead">{{ $t('salud_completa.hero_description') }}</p>
            <router-link :to="`/${currentLang}/calculadora`" class="btn btn-action" style="font-size: 1.1rem; padding: 12px 30px;">
                {{ $t('salud_completa.hero_cta') }}
            </router-link>
        </div>
    </section>
    <!-- Main Content -->
    <section class="content-section">
        <div class="container">
            <h2>{{ $t('salud_completa.section1_title') }}</h2>
            <p>{{ $t('salud_completa.section1_text') }}</p>

            <div class="feature-grid">
                <div class="feature-box">
                    <img src="/icons/Maletin-Azul.png" style="width: 15%;">
                    <h3>{{ $t('salud_completa.feature1_title') }}</h3>
                    <p>{{ $t('salud_completa.feature1_text') }}</p>
                </div>
                <div class="feature-box">
                    <img src="/icons/Cardio-Azul.png" style="width: 15%;">
                    <h3>{{ $t('salud_completa.feature2_title') }}</h3>
                    <p>{{ $t('salud_completa.feature2_text') }}</p>
                </div>
                <div class="feature-box">
                    <img src="/icons/Examen-Medico-Azul.png" style="width: 15%;">
                    <h3>{{ $t('salud_completa.feature3_title') }}</h3>
                    <p>{{ $t('salud_completa.feature3_text') }}</p>
                </div>
            </div>

            <h2 style="margin-top: 60px;">{{ $t('salud_completa.section2_title') }}</h2>
            
            <h3>{{ $t('salud_completa.coverage_title') }}</h3>
            <p><strong>{{ $t('salud_completa.coverage1_title') }}</strong> {{ $t('salud_completa.coverage1_text') }}</p>
            <p><strong>{{ $t('salud_completa.coverage2_title') }}</strong> {{ $t('salud_completa.coverage2_text') }}</p>
            <p><strong>{{ $t('salud_completa.coverage3_title') }}</strong> {{ $t('salud_completa.coverage3_text') }}</p>
            <p><strong>{{ $t('salud_completa.coverage4_title') }}</strong> {{ $t('salud_completa.coverage4_text') }}</p>
            
            <h3 style="margin-top: 40px; border-bottom: 1px solid #eee; padding-bottom: 10px;">{{ $t('salud_completa.specialties_title') }}</h3>
            <ul class="specialties-list">
                <li v-for="specialty in specialties" :key="specialty">
                    <ion-icon name="checkmark-circle"></ion-icon> {{ specialty }}
                </li>
            </ul>

            <h2 style="margin-top: 60px;">{{ $t('salud_completa.guarantees_title') }}</h2>
            <div class="feature-grid" style="margin-bottom: 40px;">
                <div class="feature-box" v-for="guarantee in guarantees" :key="guarantee.key">
                    <ion-icon :name="guarantee.icon"></ion-icon>
                    <h3>{{ guarantee.title }}</h3>
                    <p>{{ guarantee.text }}</p>
                </div>
            </div>

            <h2 style="margin-top: 60px;">{{ $t('salud_completa.waiting_periods_title') }}</h2>
            <div style="background-color: #f1f3f5; padding: 25px; border-radius: 8px;">
                <p style="font-size: 1.1rem; color: #1C4A8D; font-weight: 700; margin-bottom: 0;">
                    {{ $t('salud_completa.waiting_periods_text') }}
                </p>
            </div>
        </div>
    </section>
    <!-- Bottom CTA -->
    <section class="cta-bottom">
        <div class="container">
            <h2 style="margin-bottom: 20px;">{{ $t('salud_completa.cta_title') }}</h2>
            <p style="font-size: 1.1rem; margin-bottom: 30px; opacity: 0.9;">{{ $t('salud_completa.cta_subtitle') }}</p>
            <router-link :to="`/${currentLang}/calculadora`" class="btn btn-action" style="font-size: 1.2rem; padding: 15px 40px; box-shadow: 0 4px 15px rgba(0,0,0,0.2);">
                {{ $t('salud_completa.cta_button') }}
            </router-link>
        </div>
    </section>
    <Footer/>
    <WhatsAppFloat/>
</template>

<script>
import WhatsAppFloat from '@/components/common/WhatsAppFloat.vue';
import Footer from '@/components/layout/Footer.vue';
import Header from '@/components/layout/Header.vue';

export default {
    name: 'SaludCompleta',
    components: {
        Header,
        Footer,
        WhatsAppFloat
    },
    computed: {
        currentLang() {
            return this.$route.params.lang || 'es'
        }
    },
    data() {
        return {
            specialties: [
                this.$t('salud_completa.specialty1'),
                this.$t('salud_completa.specialty2'),
                this.$t('salud_completa.specialty3'),
                this.$t('salud_completa.specialty4'),
                this.$t('salud_completa.specialty5'),
                this.$t('salud_completa.specialty6'),
                this.$t('salud_completa.specialty7'),
                this.$t('salud_completa.specialty8'),
                this.$t('salud_completa.specialty9'),
                this.$t('salud_completa.specialty10'),
                this.$t('salud_completa.specialty11'),
                this.$t('salud_completa.specialty12'),
                this.$t('salud_completa.specialty13'),
                this.$t('salud_completa.specialty14'),
                this.$t('salud_completa.specialty15'),
                this.$t('salud_completa.specialty16'),
                this.$t('salud_completa.specialty17'),
                this.$t('salud_completa.specialty18'),
                this.$t('salud_completa.specialty19'),
                this.$t('salud_completa.specialty20'),
                this.$t('salud_completa.specialty21'),
                this.$t('salud_completa.specialty22'),
                this.$t('salud_completa.specialty23'),
                this.$t('salud_completa.specialty24'),
                this.$t('salud_completa.specialty25'),
                this.$t('salud_completa.specialty26')
            ],
            guarantees: [
                {
                    key: 'death',
                    icon: 'shield-outline',
                    title: this.$t('salud_completa.guarantee1_title'),
                    text: this.$t('salud_completa.guarantee1_text')
                },
                {
                    key: 'second_opinion',
                    icon: 'chatbubbles-outline',
                    title: this.$t('salud_completa.guarantee2_title'),
                    text: this.$t('salud_completa.guarantee2_text')
                },
                {
                    key: 'travel',
                    icon: 'airplane-outline',
                    title: this.$t('salud_completa.guarantee3_title'),
                    text: this.$t('salud_completa.guarantee3_text')
                },
                {
                    key: 'chat',
                    icon: 'logo-whatsapp',
                    title: this.$t('salud_completa.guarantee4_title'),
                    text: this.$t('salud_completa.guarantee4_text')
                },
                {
                    key: 'repatriation',
                    icon: 'earth-outline',
                    title: this.$t('salud_completa.guarantee5_title'),
                    text: this.$t('salud_completa.guarantee5_text')
                }
            ]
        }
    }
}
</script>

<style scoped>
.product-detail-hero {
    background-color: #f8f9fa;
    padding: 60px 0;
    border-bottom: 1px solid #e9ecef;
}

.product-detail-hero h1 {
    color: #1C4A8D;
    font-size: 2.5rem;
    margin-bottom: 20px;
}

.product-detail-hero p.lead {
    font-size: 1.2rem;
    color: #555;
    max-width: 800px;
    margin-bottom: 30px;
}

.content-section {
    padding: 60px 0;
}

.content-section h2 {
    color: #1C4A8D;
    border-bottom: 2px solid #1C4A8D;
    padding-bottom: 10px;
    margin-bottom: 30px;
    display: inline-block;
}

.content-section h3 {
    color: #333;
    margin-top: 30px;
    margin-bottom: 15px;
    font-size: 1.4rem;
}

.content-section p {
    margin-bottom: 15px;
    color: #555;
    line-height: 1.7;
}

.feature-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 30px;
    margin-top: 40px;
}

.feature-box {
    background: white;
    padding: 25px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0,0,0,0.05);
    border-top: 4px solid #1C4A8D;
}

.feature-box ion-icon {
    font-size: 2rem;
    color: #1C4A8D;
    margin-bottom: 15px;
}

.specialties-list {
    column-count: 2;
    column-gap: 40px;
    list-style: none;
    padding: 0;
}

.specialties-list li {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 10px;
    color: #555;
}

.specialties-list ion-icon {
    color: #F04B00;
}

.cta-bottom {
    background-color: #1C4A8D;
    color: white;
    text-align: center;
    padding: 60px 0;
}

.cta-bottom h2 {
    color: white;
    border: none;
}

@media (max-width: 768px) {
    .specialties-list {
        column-count: 1;
    }
}
</style>